var map = {
	"./pages_landscape_fewer.png": 77009,
	"./pages_landscape_high.png": 47760,
	"./pages_landscape_highest.png": 62170,
	"./pages_landscape_moderate.png": 5271,
	"./pages_landscape_single.png": 52700,
	"./pages_portrait_fewer.png": 41741,
	"./pages_portrait_high.png": 33340,
	"./pages_portrait_highest.png": 20462,
	"./pages_portrait_moderate.png": 82891,
	"./pages_portrait_single.png": 44576,
	"./pages_square_fewer.png": 48453,
	"./pages_square_high.png": 65460,
	"./pages_square_highest.png": 38262,
	"./pages_square_moderate.png": 58195,
	"./pages_square_single.png": 65592
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47038;